<template lang="pug">
  .notification
    router-link.notification__text(to="/menyu") Бесплатная доставка от 500 ₽
    SvgIcon(name="clip" width="19" height="46" class="notification__clip")
    .notification__arrow-wr
      SvgIcon(name="arrow-left" width="7" height="12" class="notification__arrow")
</template>

<script>
//import '@/components/common/notification/notification.styl';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue'

export default {
  components: {
    SvgIcon
  },

  name: 'notification',

  mixins: [],

  props: {},

  created() {
    this.initScripts()
  },

  methods: {
    initScripts() {
      this.$nextTick(() => {
        $(document).on('click', '.notification__arrow-wr', function () {
          $('.notification').toggleClass('notification--show')
        })

        $(document).on('click', '.notification__text', function () {
          $('.notification').removeClass('notification--show')
        })

        setTimeout(() => {
          $('.notification').addClass('notification--show')
        }, 2500)
      })
    }
  }
}
</script>
